<button class="user-btn" [matMenuTriggerFor]="menu">
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 0.25C4.62402 0.25 0.25 4.62402 0.25 10C0.25 15.376 4.62402 19.75 10 19.75C15.376 19.75 19.75 15.376 19.75 10C19.75 4.62402 15.376 0.25 10 0.25ZM10 1.75C14.5645 1.75 18.25 5.43555 18.25 10C18.25 14.5645 14.5645 18.25 10 18.25C5.43555 18.25 1.75 14.5645 1.75 10C1.75 5.43555 5.43555 1.75 10 1.75ZM10 4C7.9375 4 6.25 5.6875 6.25 7.75C6.25 8.88672 6.78027 9.89746 7.58594 10.5859C5.89844 11.4619 4.75 13.2256 4.75 15.25H6.25C6.25 13.1699 7.91992 11.5 10 11.5C12.0801 11.5 13.75 13.1699 13.75 15.25H15.25C15.25 13.2256 14.1016 11.4619 12.4141 10.5859C13.2197 9.89746 13.75 8.88672 13.75 7.75C13.75 5.6875 12.0625 4 10 4ZM10 5.5C11.251 5.5 12.25 6.49902 12.25 7.75C12.25 9.00098 11.251 10 10 10C8.74902 10 7.75 9.00098 7.75 7.75C7.75 6.49902 8.74902 5.5 10 5.5Z"
      fill="currentColor" />
  </svg>
</button>

<mat-menu #menu="matMenu">
  @for (item of navService.menuItems; track item.name) {
    @if (item.name !== 'Sign Out' && canShowItem(item)) {
      @if (item.path) {
        <a mat-menu-item class="nav-item" [routerLink]="item.path">
          <mat-icon>{{ item.icon }}</mat-icon>
          {{ item.name | translate }}
        </a>
      } @else {
        <button mat-menu-item class="nav-item" (click)="handleNonRouteItems(item.name)">
          <mat-icon>{{ item.icon }}</mat-icon>
          {{ item.name | translate }}
        </button>
      }
    }
  }

  @if (supportChannelService.hasAny()) {
    <button mat-menu-item class="nav-item" [matMenuTriggerFor]="supportMenu">
      <mat-icon>support_agent</mat-icon>
      {{ 'Customer Support' | translate }}
    </button>
  }

  <button mat-menu-item class="nav-item" (click)="handleNonRouteItems('Sign Out')">
    <mat-icon>logout</mat-icon>
    {{ 'Sign Out' | translate }}
  </button>
</mat-menu>

<mat-menu #supportMenu="matMenu">
  @if (supportChannelService.whatsapp(); as wa) {
    @if (wa.WEB_LINK) {
      <a mat-menu-item class="nav-item" [href]="wa.WEB_LINK" target="_blank" rel="noopener noreferrer">
        <mat-icon style="color: #25D366;">chat</mat-icon>
        WhatsApp
      </a>
      @if (wa.QR_URL) {
        <button mat-menu-item class="nav-item" (click)="openQr(wa.QR_URL, 'WhatsApp', 'whatsapp', wa.WEB_LINK)">
          <mat-icon style="color: #25D366;">qr_code</mat-icon>
          WhatsApp QR
        </button>
      }
    }
  }

  @if (supportChannelService.telegram(); as tg) {
    @if (tg.WEB_LINK) {
      <a mat-menu-item class="nav-item" [href]="tg.WEB_LINK" target="_blank" rel="noopener noreferrer">
        <mat-icon style="color: #229ED9;">send</mat-icon>
        Telegram
      </a>
      @if (tg.QR_URL) {
        <button mat-menu-item class="nav-item" (click)="openQr(tg.QR_URL, 'Telegram', 'telegram', tg.WEB_LINK)">
          <mat-icon style="color: #229ED9;">qr_code</mat-icon>
          Telegram QR
        </button>
      }
    }
  }
</mat-menu>
